import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import FormatDate from "../../formatdatetime";
import Pagination from "../../pagination";
import { baseurl } from "../../constant";
import Loading from "../../loading";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";

const UpiCollectionHistory = () => {
  const [data, setdata] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState(0);
  const [loading, setloading] = useState(false);
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [err, seterr] = useState();
  const [totalSuccessAmount, settotalSuccessAmount] = useState(0);
  const [totalSuccessRecord, settotalSuccessRecord] = useState(0);
  const [totalChargeAmount, settotalChargeAmount] = useState(0);
  const [totalChargeRecord, settotalChargeRecord] = useState(0);
  const [totalFailedAmount, settotalFailedAmount] = useState(0);
  const [totalFailedRecord, settotalFailedRecord] = useState(0);
  const [datalength, setdatalength] = useState();

  // const formatRupee = (value) => {
  //   return value.toLocaleString("en-IN", {
  //     style: "currency",
  //     currency: "INR",
  //     maximumFractionDigits: 2,
  //   });
  // };

  const formattedNumber = (number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(number);

  // const viewall = async () => {

  //   setstartdate("");
  //   setenddate("");
  //   setkeyword("");
  //   setstatus("");
  //   getdata();
  // };
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Users table",
    sheet: "Users",
  });

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);
  // const SerialNumber = (currentPage - 1) * pageRecord + index;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Pagination(totalPage, currentPage);

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(1, currentPage - 1, currentPage, currentPage + 1, totalPage);
    }
  }

  // const getdata1 = async () => {
  //   try {

  //     setloading(true);
  //     const result = await axios.post(baseurl + "upiCollectionReportAuth", {
  //       token: token,
  //       pageno: currentPage,
  //       pageRecord: pageRecord,
  //       fromDate: startdate.replaceAll('/', '-'),
  //       fromDate: enddate.replaceAll('/', '-'),
  //       keyword: keyword,
  //       status: status,
  //     });

  //     setdata(result.data);
  //     settotalrecord(result.data.totalRecord);
  //     settotalSuccessAmount(result.data.totalSuccessAmount);
  //     settotalSuccessRecord(result.data.totalSuccessRecord);
  //     settotalChargeAmount(result.data.totalChargeAmount);
  //     settotalChargeRecord(result.data.totalChargeRecord);
  //     settotalFailedAmount(result.data.totalFailedAmount);
  //     settotalFailedRecord(result.data.totalFailedRecord);
  //     setdatalength(result.data.data.length);
  //     setloading(false);
  //   } catch (err) {
  //     seterr(err);
  //   }
  // };

  const getdata = async () => {
    try {
      setloading(true);
      const result = await axios.post(baseurl + "upiCollectionReportAuth", {
        token: token,
        pageno: currentPage,
        pageRecord: pageRecord,
        fromDate: startdate,
        toDate: enddate,
        keyword: keyword,
        status: status,
      });

      setdata(result.data);
      settotalrecord(result.data.totalRecord);
      settotalSuccessAmount(result.data.totalSuccessAmount);
      settotalSuccessRecord(result.data.totalSuccessRecord);
      settotalChargeAmount(result.data.totalChargeAmount);
      settotalChargeRecord(result.data.totalChargeRecord);
      settotalFailedAmount(result.data.totalFailedAmount);
      settotalFailedRecord(result.data.totalFailedRecord);
      setdatalength(result.data.data.length);
      setloading(false);
    } catch (err) {
      seterr(err);
    }
  };

  useEffect(() => {
    getdata();
  }, [currentPage]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-4 col-md-6 mb-2 mt-2">
            <div className="card border-left-success shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      <a href="#">Total Success</a>
                    </div>
                    <div
                      className="h5 mb-0 font-weight-bold text-gray-800"
                      id="totalSuccessRechargeBlock"
                    >
                      {formattedNumber(totalSuccessAmount)}/{totalSuccessRecord}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6 mb-2 mt-2">
            <div className="card border-left-success shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      <a href="#">Total Success Charge</a>
                    </div>
                    <div
                      className="h5 mb-0 font-weight-bold text-gray-800"
                      id="totalSuccessChargeBlock"
                    >
                      {formattedNumber(totalChargeAmount)} / {totalChargeRecord}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6 mb-2 mt-2">
            <div className="card border-left-danger shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                      <a href="#">Total Failed</a>
                    </div>
                    <div
                      className="h5 mb-0 font-weight-bold text-gray-800"
                      id="totalFailedRechargeBlock"
                    >
                      {formattedNumber(totalFailedAmount)}/ {totalFailedRecord}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <form id="leadFilterForm" method="post" accept-charset="utf-8">
              <div className="row">
                <div className="col-sm-4">
                  <h4>
                    <b>UPI Collection History</b>
                  </h4>
                </div>

                <div className="col-sm-2">
                  <input
                    type="date"
                    className="form-control datepick"
                    placeholder={startdate}
                    autocomplete="off"
                    name="from_date"
                    value={startdate}
                    onChange={(e) => {
                      setstartdate(e.target.value);
                    }}
                  />
                </div>

                <div className="col-sm-2">
                  <input
                    type="date"
                    className="form-control datepick"
                    placeholder={enddate}
                    autocomplete="off"
                    name="to_date"
                    value={enddate}
                    onChange={(e) => {
                      setenddate(e.target.value);
                    }}
                  />
                </div>

                <div className="col-sm-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Keyword"
                    name="keyword"
                    value={keyword}
                    onChange={(e) => {
                      setkeyword(e.target.value);
                    }}
                  />
                </div>

                <div className="col-sm-2">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => (setCurrentPage(1), getdata())}
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>{" "}
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div>
                  <Loading />
                </div>
              ) : (
                <table
                  ref={tableRef}
                  className="table table-bordered table-striped"
                  id="upiTransactionDataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Member</th>
                      <th>TxnID</th>
                      <th>Bank RRN</th>
                      <th>Amount</th>
                      <th>Charge</th>
                      <th>Credit</th>
                      <th>VPA ID</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Date Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      datalength > 0 ? (
                        data.data.map((item, index) => (
                          <tr>
                            <td>
                              {(currentPage - 1) * pageRecord + index + 1}
                            </td>
                            <td>
                              {item.user_code}
                              <br />
                              {item.name}
                            </td>
                            <td>{item.txnid}</td>
                            <td>{item.bank_rrno}</td>
                            <td>{formattedNumber(item.amount)}/-</td>
                            <td>{formattedNumber(item.charge_amount)}/-</td>
                            <td>{formattedNumber(item.credit_amount)}/-</td>
                            <td>{item.vpa_id}</td>
                            <td>{item.description}</td>
                            {(item.status == 4 || item.status == 0) && (
                              <td style={{ color: "red" }}>Failed</td>
                            )}
                            {item.status == 3 && (
                              <td style={{ color: "orange" }}>Pending</td>
                            )}
                            {item.status == 2 && (
                              <td style={{ color: "green" }}>Success</td>
                            )}
                            <td>{FormatDate(item.created)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colspan="11" style={{ textAlign: "center" }}>
                            There is no data in table
                          </th>
                        </tr>
                      )
                      //  (
                      //   <tr>
                      //     <pstyle={{ textAlign: "center" }}
                      //       style={{
                      //         backgroundColor: "#D3D3D3",
                      //         textAlign: "center",
                      //       }}
                      //     >
                      //       No data available in table
                      //     </pstyle=>
                      //   </tr>
                      // )
                    }
                  </tbody>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Member</th>
                      <th>TxnID</th>
                      <th>Bank RRN</th>
                      <th>Amount</th>
                      <th>Charge</th>
                      <th>Credit</th>
                      <th>VPA ID</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Date Time</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              )}
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  padding: "10px 15px",
                  margin: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                previous
              </button>

              {pages.map((page, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(page)}
                  style={{
                    padding: "10px 15px",
                    margin: "5px",
                    backgroundColor: currentPage === page ? "red" : "#f0f0f0",
                    color: currentPage === page ? "#fff" : "#000",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    cursor: page === "..." ? "default" : "pointer",
                    fontWeight: page === "..." ? "bold" : "normal",
                  }}
                  disabled={page === "..."}
                >
                  {page}
                </button>
              ))}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPage || datalength === 0}
                style={{
                  padding: "10px 15px",
                  margin: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpiCollectionHistory;
